<template>
    <div class="attach_seo">

        <div  >
            <yes_no
                key="NO_INDEX"
                title="NO_INDEX"
                v-model="no_index"
            >
            </yes_no>
        </div>

        <info_field
            :is_disabled="this.is_disabled"
            f_uniq="meta_key"
            f_type="meta_key"
            @update_categ="change_atr"
            :f_title="__t('META_CODE')"
            :f_val=seo.meta_key>
        </info_field>

        <info_field
            :is_disabled="this.is_disabled"
            f_uniq="pixel_code"
            f_type="pixel_code"
            @update_categ="change_atr"
            :f_title="__t('FB_PIXEL_CODE')"
            :f_val=seo.pixel_code>
        </info_field>

        <info_field
            :is_disabled="this.is_disabled"
            f_uniq="gtag_code"
            f_type="gtag_code"
            @update_categ="change_atr"
            :f_title="__t('GTAG4_CODE')"
            :f_val=seo.gtag_code>
        </info_field>

        <info_field
            :is_disabled="this.is_disabled"
            f_uniq="google_measurement_key"
            f_type="google_measurement_key"
            @update_categ="change_atr"
            :f_title="__t('google_measurement_key')"
            :f_val=seo.google_measurement_key>
        </info_field>


        <info_field
            :is_disabled="this.is_disabled"
            f_uniq="ga_code"
            f_type="ga_code"
            @update_categ="change_atr"
            :f_title="__t('GA_CODE')"
            :f_val=seo.ga_code>
        </info_field>

        <info_field
            :is_disabled="this.is_disabled"
            f_uniq="tiktok_code"
            f_type="tiktok_code"
            @update_categ="change_atr"
            :f_title="__t('TIKTOK_CODE')"
            :f_val=seo.tiktok_code>
        </info_field>

        <info_field
            :is_disabled="this.is_disabled"
            f_uniq="seo_title"
            f_type="seo_title"
            @update_categ="change_atr"
            :f_title="__t('SEO_MAIN_TITLE')"
            :f_val=seo.seo_title>
        </info_field>

        <info_field
            :is_disabled="this.is_disabled"
            f_uniq="seo_description"
            f_type="seo_description"
            @update_categ="change_atr"
            :f_title="__t('SEO_MAIN_DESCRIPTION')"
            :f_val=seo.seo_description>
        </info_field>

    </div>

</template>

<script>
import info_field from "../../../../../sys/info_field.vue";
import yes_no from "../../../../../sys/radio/yes_no.vue";

export default {
    name: "pwa_seo",
    components : {
        yes_no,
        info_field,
    },
    props : {
        pwa : {
            type:Object
        }
    },

    methods : {
        change_atr(atr_name,atr_val) {
            if(this.pwa.seo.hasOwnProperty(atr_name)) {
                this.pwa.seo[atr_name] = atr_val;
            }
        }
    },

    computed : {

        seo() {
            return this.pwa.seo;
        },
        is_disabled() {
            return false;
        },

        no_index : {
            get()  {
                return this.pwa.seo.no_index;
            },
            set(val)  {
               this.change_atr('no_index',val);
            }
        },
    }
}
</script>



<style scoped>

</style>
